<template>
  <div :class="['definition-wrapper', 'cron', definition.id, {'error_validate': mandatoryValidation || validation }]">
    <div v-if="editable" id="changeContab">
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> {{text.Seconds.name}}</span>
          <div class="tabBody">
            <el-row>
              <el-radio v-model="second.cronEvery" label="1">{{text.Seconds.every}}</el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="second.cronEvery" label="2">{{text.Seconds.interval[0]}}
                <el-input-number size="small" v-model="second.incrementIncrement" :min="1" :max="60"></el-input-number>
                {{text.Seconds.interval[1]||''}}
                <el-input-number size="small" v-model="second.incrementStart" :min="0" :max="59"></el-input-number>
                {{text.Seconds.interval[2]||''}}
              </el-radio>
            </el-row>
            <el-row>
              <el-radio class="long" v-model="second.cronEvery" label="3">{{text.Seconds.specific}}
                <el-select size="small" multiple :placeholder="getLang('select')" v-model="second.specificSpecific">
                  <el-option v-for="val in 60" :key="val" :value="val-1">{{val-1}}</el-option>
                </el-select>
              </el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="second.cronEvery" label="4">{{text.Seconds.cycle[0]}}
                <el-input-number size="small" v-model="second.rangeStart" :min="1" :max="60"></el-input-number>
                {{text.Seconds.cycle[1]||''}}
                <el-input-number size="small" v-model="second.rangeEnd" :min="0" :max="59"></el-input-number>
                {{text.Seconds.cycle[2]||''}}
              </el-radio>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> {{text.Minutes.name}}</span>
          <div class="tabBody">
            <el-row>
              <el-radio v-model="minute.cronEvery" label="1">{{text.Minutes.every}}</el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="minute.cronEvery" label="2">{{text.Minutes.interval[0]}}
                <el-input-number size="small" v-model="minute.incrementIncrement" :min="1" :max="60"></el-input-number>
                {{text.Minutes.interval[1]}}
                <el-input-number size="small" v-model="minute.incrementStart" :min="0" :max="59"></el-input-number>
                {{text.Minutes.interval[2]||''}}
              </el-radio>
            </el-row>
            <el-row>
              <el-radio class="long" v-model="minute.cronEvery" label="3">{{text.Minutes.specific}}
                <el-select size="small" multiple :placeholder="getLang('select')" v-model="minute.specificSpecific">
                  <el-option v-for="val in 60" :key="val" :value="val-1">{{val-1}}</el-option>
                </el-select>
              </el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="minute.cronEvery" label="4">{{text.Minutes.cycle[0]}}
                <el-input-number size="small" v-model="minute.rangeStart" :min="1" :max="60"></el-input-number>
                {{text.Minutes.cycle[1]}}
                <el-input-number size="small" v-model="minute.rangeEnd" :min="0" :max="59"></el-input-number>
                {{text.Minutes.cycle[2]}}
              </el-radio>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> {{text.Hours.name}}</span>
          <div class="tabBody">
            <el-row>
              <el-radio v-model="hour.cronEvery" label="1">{{text.Hours.every}}</el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="hour.cronEvery" label="2">{{text.Hours.interval[0]}}
                <el-input-number size="small" v-model="hour.incrementIncrement" :min="1" :max="24"></el-input-number>
                {{text.Hours.interval[1]}}
                <el-input-number size="small" v-model="hour.incrementStart" :min="0" :max="23"></el-input-number>
                {{text.Hours.interval[2]}}
              </el-radio>
            </el-row>
            <el-row>
              <el-radio class="long" v-model="hour.cronEvery" label="3">{{text.Hours.specific}}
                <el-select size="small" multiple :placeholder="getLang('select')" v-model="hour.specificSpecific">
                  <el-option v-for="val in 24" :key="val" :value="val-1">{{val-1}}</el-option>
                </el-select>
              </el-radio>
            </el-row>
            <el-row>
              <el-radio v-model="hour.cronEvery" label="4">{{text.Hours.cycle[0]}}
                <el-input-number size="small" v-model="hour.rangeStart" :min="0" :max="23"></el-input-number>
                {{text.Hours.cycle[1]}}
                <el-input-number size="small" v-model="hour.rangeEnd" :min="0" :max="23"></el-input-number>
                {{text.Hours.cycle[2]}}
              </el-radio>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> {{text.Day.name}}</span>
            <div class="tabBody">
              <el-row>
                <el-radio v-model="day.cronEvery" label="1">{{text.Day.every}}</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="2">{{text.Day.intervalWeek[0]}}
                  <el-input-number size="small" v-model="week.incrementIncrement" :min="1" :max="7"></el-input-number>
                  {{text.Day.intervalWeek[1]}}
                  <el-select size="small" :placeholder="getLang('select')" v-model="week.incrementStart">
                    <el-option v-for="val in 7" :key="val" :label="text.Week[val-1]" :value="val"></el-option>
                  </el-select>
                  {{text.Day.intervalWeek[2]}}
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="3">{{text.Day.intervalDay[0]}}
                  <el-input-number size="small" v-model="day.incrementIncrement" :min="1" :max="31"></el-input-number>
                  {{text.Day.intervalDay[1]}}
                  <el-input-number size="small" v-model="day.incrementStart" :min="1" :max="31"></el-input-number>
                  {{text.Day.intervalDay[2]}}
                </el-radio>
              </el-row>
              <el-row>
                <el-radio class="long" v-model="day.cronEvery" label="4">{{text.Day.specificWeek}}
                  <el-select size="small" multiple :placeholder="getLang('select')" v-model="week.specificSpecific">
                    <el-option v-for="val in 7"
                     :key="val"
                     :label="text.Week[val-1]"
                     :value="['SUN','MON','TUE','WED','THU','FRI','SAT'][val-1]"
                    ></el-option>
                  </el-select>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio class="long" v-model="day.cronEvery" label="5">{{text.Day.specificDay}}
                  <el-select size="small" multiple :placeholder="getLang('select')" v-model="day.specificSpecific">
                    <el-option v-for="val in 31" :key="val" :value="val">{{val}}</el-option>
                  </el-select>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="6">{{text.Day.lastDay}}</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="7">{{text.Day.lastWeekday}}</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="8">{{text.Day.lastWeek[0]}}
                  <el-select size="small" :placeholder="getLang('select')" v-model="day.cronLastSpecificDomDay">
                    <el-option v-for="val in 7" :key="val" :label="text.Week[val-1]" :value="val"></el-option>
                  </el-select>
                  {{text.Day.lastWeek[1]||''}}
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="9">
                  <el-input-number size="small" v-model="day.cronDaysBeforeEomMinus" :min="1" :max="31"></el-input-number>
                  {{text.Day.beforeEndMonth[0]}}
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="10">{{text.Day.nearestWeekday[0]}}
                  <el-input-number size="small" v-model="day.cronDaysNearestWeekday" :min="1" :max="31"></el-input-number>
                  {{text.Day.nearestWeekday[1]}}
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="day.cronEvery" label="11">{{text.Day.someWeekday[0]}}
                  <el-input-number size="small" v-model="week.cronNthDayNth" :min="1" :max="5"></el-input-number>
                  <el-select size="small" :placeholder="getLang('select')" v-model="week.cronNthDayDay">
                    <el-option v-for="val in 7" :key="val" :label="text.Week[val-1]" :value="val"></el-option>
                  </el-select>
                  {{text.Day.someWeekday[1]}}
                </el-radio>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label"><i class="el-icon-date"></i> {{text.Month.name}}</span>
            <div class="tabBody">
              <el-row>
                <el-radio v-model="month.cronEvery" label="1">{{text.Month.every}}</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="month.cronEvery" label="2">{{text.Month.interval[0]}}
                  <el-input-number size="small" v-model="month.incrementIncrement" :min="1" :max="12"></el-input-number>
                  {{text.Month.interval[1]}}
                  <el-input-number size="small" v-model="month.incrementStart" :min="1" :max="12"></el-input-number>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio class="long" v-model="month.cronEvery" label="3">{{text.Month.specific}}
                  <el-select size="small" multiple :placeholder="getLang('select')" v-model="month.specificSpecific">
                    <el-option v-for="val in 12" :key="val" :label="val" :value="val"></el-option>
                  </el-select>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="month.cronEvery" label="4">{{text.Month.cycle[0]}}
                  <el-input-number size="small" v-model="month.rangeStart" :min="1" :max="12"></el-input-number>
                  {{text.Month.cycle[1]}}
                  <el-input-number size="small" v-model="month.rangeEnd" :min="1" :max="12"></el-input-number>
                </el-radio>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label"><i class="el-icon-date"></i> {{text.Year.name}}</span>
            <div class="tabBody">
              <el-row>
                <el-radio v-model="year.cronEvery" label="1">{{text.Year.every}}</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="year.cronEvery" label="2">{{text.Year.interval[0]}}
                  <el-input-number size="small" v-model="year.incrementIncrement" :min="1" :max="99"></el-input-number>
                  {{text.Year.interval[1]}}
                  <el-input-number size="small" v-model="year.incrementStart" :min="2018" :max="2118"></el-input-number>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio class="long" v-model="year.cronEvery" label="3">{{text.Year.specific}}
                  <el-select size="small" filterable multiple :placeholder="getLang('select')" v-model="year.specificSpecific">
                    <el-option v-for="val in 100" :key="val" :label="2017+val" :value="2017+val"></el-option>
                  </el-select>
                </el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="year.cronEvery" label="4">{{text.Year.cycle[0]}}
                  <el-input-number size="small" v-model="year.rangeStart"  :min="2018" :max="2118"></el-input-number>
                  {{text.Year.cycle[1]}}
                  <el-input-number size="small" v-model="year.rangeEnd"  :min="2018" :max="2118"></el-input-number>
                </el-radio>
              </el-row>
            </div>
          </el-tab-pane>
      </el-tabs>
      <div class="bottom">
        <span class="value">{{this.cron}}</span>
      </div>
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :languageSelected="languageSelected" :visualDefinition="visualDefinition" />
  </div>
</template>

<script>
import Vue from 'vue'
import DefinitionReadOnly from './readOnly'
import ElementUI from 'element-ui'
import moment from 'moment'
import language from '../language'

Vue.use(ElementUI)

export default {
  name: 'definition-cron',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'apiparams',
    'placeholder',
    'callTask'
  ],
  components: {
    DefinitionReadOnly
  },
  data () {
    return {
      cronValue: '',
      validation: null,
      second: {
        cronEvery: '',
        incrementStart: '',
        incrementIncrement: '',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: []
      },
      minute: {
        cronEvery: '',
        incrementStart: '',
        incrementIncrement: '',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: []
      },
      hour: {
        cronEvery: '',
        incrementStart: '',
        incrementIncrement: '',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: []
      },
      day: {
        cronEvery: '',
        incrementStart: '1',
        incrementIncrement: '1',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: [],
        cronLastSpecificDomDay: 1,
        cronDaysBeforeEomMinus: '',
        cronDaysNearestWeekday: ''
      },
      week: {
        incrementStart: '',
        incrementIncrement: '',
        specificSpecific: [],
        cronNthDayDay: 1,
        cronNthDayNth: '1'
      },
      month: {
        cronEvery: '',
        incrementStart: '',
        incrementIncrement: '',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: []
      },
      year: {
        cronEvery: '',
        incrementStart: '',
        incrementIncrement: '',
        rangeStart: '',
        rangeEnd: '',
        specificSpecific: []
      },
      output: {
        second: '',
        minute: '',
        hour: '',
        day: '',
        month: '',
        Week: '',
        year: ''
      }
    }
  },
  methods: {
    // 1. Launch validate mandatory
    valueChanged () {
      this.setObjectTextValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    setObjectTextValue () {
      if (this.cron === '* * * * * ? *') {
        this.cronValue = ''
      } else {
        this.cronValue = this.cron
      }
      this.object.textValue = this.cronValue
    },
    setCronValue () {
      if (this.object.textValue) {
        this.cronValue = this.object.textValue
        this.initCronObj()
      } else if (this.cron === '* * * * * ? *') {
        this.cronValue = ''
      } else {
        this.cronValue = this.cron
      }
    },
    validateCronFormat () {
      // 3. launch refresh definition event
      this.$emit('refreshDefinition', this.object)
    },
    getValue () {
      return this.cron
    },
    initCronObj () {
      var cronValues = this.object.textValue.split(' ')
      if (cronValues.length === 7) {
        // seconds
        this.setDefaultCronObj(cronValues[0], this.second)
        // minutes
        this.setDefaultCronObj(cronValues[1], this.minute)
        // hours
        this.setDefaultCronObj(cronValues[2], this.hour)
        // days/weeks
        this.setDayWeekCronObj(cronValues[3], cronValues[5])
        // months
        this.setDefaultCronObj(cronValues[4], this.month)
        // years
        this.setDefaultCronObj(cronValues[6], this.year)
      }
    },
    setDefaultCronObj (value, obj) {
      var defaultValue = '*'
      if (value !== defaultValue) {
        var everyStarting = '/'
        var everyBetween = '-'
        var specific = ','
        var values = null
        // every starting
        if (value.indexOf(everyStarting) > -1) {
          values = value.split(everyStarting)
          if (values.length === 2) {
            obj.cronEvery = '2'
            obj.incrementIncrement = parseInt(values[1])
            obj.incrementStart = parseInt(values[0])
          }
        // every between
        } else if (value.indexOf(everyBetween) > -1) {
          values = value.split(everyBetween)
          if (values.length === 2) {
            obj.cronEvery = '4'
            obj.rangeStart = parseInt(values[0])
            obj.rangeEnd = parseInt(values[1])
          }
        // specific values
        } else {
          values = value.split(specific)
          obj.cronEvery = '3'
          for (var i = 0; i < values.length; i++) {
            obj.specificSpecific.push(parseInt(values[i]))
          }
        }
      // default value
      } else {
        obj.cronEvery = '1'
      }
    },
    setDayWeekCronObj (dayExp, weekExp) {
      var dayDefaultValue = '*'
      var weekDefaultValue = '?'
      if (dayExp !== dayDefaultValue || weekExp !== weekDefaultValue) {
        var everyStarting = '/'
        var specific = ','
        var nthWeekday = '#'
        var values = null
        // every starting week day
        if (weekExp.indexOf(everyStarting) > -1 && dayExp === weekDefaultValue) {
          values = weekExp.split(everyStarting)
          if (values.length === 2) {
            this.day.cronEvery = '2'
            this.week.incrementIncrement = parseInt(values[1])
            this.week.incrementStart = parseInt(values[0])
          }
        // every starting month day
        } else if (dayExp.indexOf(everyStarting) > -1 && weekExp === weekDefaultValue) {
          values = dayExp.split(everyStarting)
          if (values.length === 2) {
            this.day.cronEvery = '3'
            this.day.incrementIncrement = parseInt(values[1])
            this.day.incrementStart = parseInt(values[0])
          }
        // specific week days
        } else if (
          (dayExp === weekDefaultValue && weekExp === weekDefaultValue) ||
          (dayExp === weekDefaultValue && weekExp.indexOf(specific) > -1)
        ) {
          this.day.cronEvery = '4'
          values = weekExp.split(specific)
          for (var i = 0; i < values.length; i++) {
            this.week.specificSpecific.push(values[i])
          }
        // specific month days
        } else if (weekExp === weekDefaultValue && dayExp.indexOf(specific) > -1) {
          this.day.cronEvery = '5'
          values = dayExp.split(specific)
          for (var j = 0; j < values.length; j++) {
            this.day.specificSpecific.push(values[j])
          }
        // last month day
        } else if (weekExp === weekDefaultValue && dayExp === 'L') {
          this.day.cronEvery = '6'
        // last week work day
        } else if (weekExp === weekDefaultValue && dayExp === 'LW') {
          this.day.cronEvery = '7'
        // last week day of the month
        } else if (weekExp === weekDefaultValue && dayExp.substr(1, 1) === 'L') {
          this.day.cronEvery = '8'
          this.day.cronLastSpecificDomDay = parseInt(dayExp.substr(0, 1))
        // days before month's end
        } else if (weekExp === weekDefaultValue && dayExp.substr(0, 2) === 'L-') {
          this.day.cronEvery = '9'
          this.day.cronDaysBeforeEomMinus = parseInt(dayExp.substr(2))
        // days before month's end
        } else if (weekExp === weekDefaultValue && dayExp.substr(dayExp.length - 1) === 'W') {
          this.day.cronEvery = '10'
          this.day.cronDaysNearestWeekday = parseInt(dayExp.substr(0, dayExp.length - 1))
        // the nth weekday of the month
        } else if (dayExp === weekDefaultValue && weekExp.indexOf(nthWeekday) > -1) {
          values = weekExp.split(nthWeekday)
          if (values.length === 2) {
            this.day.cronEvery = '11'
            this.week.cronNthDayDay = parseInt(values[1])
            this.week.cronNthDayNth = parseInt(values[0])
          }
        }
      } else {
        this.day.cronEvery = '1'
      }
    },
    getLang (key, params, values) {
      return language(this.language, key, params, values)
    }
  },
  beforeMount () {
    this.setCronValue()
  },
  computed: {
    text () {
      return language(this.language, 'cron')
    },
    secondsText () {
      let seconds = ''
      let cronEvery = this.second.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          seconds = '*'
          break
        case '2':
          seconds = this.second.incrementStart + '/' + this.second.incrementIncrement
          break
        case '3':
          this.second.specificSpecific.map(val => {
            seconds += val + ','
          })
          seconds = seconds.slice(0, -1)
          break
        case '4':
          seconds = this.second.rangeStart + '-' + this.second.rangeEnd
          break
      }
      return seconds
    },
    minutesText () {
      let minutes = ''
      let cronEvery = this.minute.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          minutes = '*'
          break
        case '2':
          minutes = this.minute.incrementStart + '/' + this.minute.incrementIncrement
          break
        case '3':
          this.minute.specificSpecific.map(val => {
            minutes += val + ','
          })
          minutes = minutes.slice(0, -1)
          break
        case '4':
          minutes = this.minute.rangeStart + '-' + this.minute.rangeEnd
          break
      }
      return minutes
    },
    hoursText () {
      let hours = ''
      let cronEvery = this.hour.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          hours = '*'
          break
        case '2':
          hours = this.hour.incrementStart + '/' + this.hour.incrementIncrement
          break
        case '3':
          this.hour.specificSpecific.map(val => {
            hours += val + ','
          })
          hours = hours.slice(0, -1)
          break
        case '4':
          hours = this.hour.rangeStart + '-' + this.hour.rangeEnd
          break
      }
      return hours
    },
    daysText () {
      let days = ''
      let cronEvery = this.day.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          break
        case '2':
        case '4':
        case '11':
          days = '?'
          break
        case '3':
          days = this.day.incrementStart + '/' + this.day.incrementIncrement
          break
        case '5':
          this.day.specificSpecific.map(val => {
            days += val + ','
          })
          days = days.slice(0, -1)
          break
        case '6':
          days = 'L'
          break
        case '7':
          days = 'LW'
          break
        case '8':
          days = this.day.cronLastSpecificDomDay + 'L'
          break
        case '9':
          days = 'L-' + this.day.cronDaysBeforeEomMinus
          break
        case '10':
          days = this.day.cronDaysNearestWeekday + 'W'
          break
      }
      return days
    },
    weeksText () {
      let weeks = ''
      let cronEvery = this.day.cronEvery
      switch (cronEvery.toString()) {
        case '1':
        case '3':
        case '5':
          weeks = '?'
          break
        case '2':
          weeks = this.week.incrementStart + '/' + this.week.incrementIncrement
          break
        case '4':
          this.week.specificSpecific.map(val => {
            weeks += val + ','
          })
          weeks = weeks.slice(0, -1)
          break
        case '6':
        case '7':
        case '8':
        case '9':
        case '10':
          weeks = '?'
          break
        case '11':
          weeks = this.week.cronNthDayDay + '#' + this.week.cronNthDayNth
          break
      }
      return weeks
    },
    monthsText () {
      let months = ''
      let cronEvery = this.month.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          months = '*'
          break
        case '2':
          months = this.month.incrementStart + '/' + this.month.incrementIncrement
          break
        case '3':
          this.month.specificSpecific.map(val => {
            months += val + ','
          })
          months = months.slice(0, -1)
          break
        case '4':
          months = this.month.rangeStart + '-' + this.month.rangeEnd
          break
      }
      return months
    },
    yearsText () {
      let years = ''
      let cronEvery = this.year.cronEvery
      switch (cronEvery.toString()) {
        case '1':
          years = '*'
          break
        case '2':
          years = this.year.incrementStart + '/' + this.year.incrementIncrement
          break
        case '3':
          this.year.specificSpecific.map(val => {
            years += val + ','
          })
          years = years.slice(0, -1)
          break
        case '4':
          years = this.year.rangeStart + '-' + this.year.rangeEnd
          break
      }
      return years
    },
    cron () {
      return `${this.secondsText || '*'} ${this.minutesText || '*'} ${this.hoursText || '*'} ${this.daysText || '*'} ${this.monthsText || '*'} ${this.weeksText || '?'} ${this.yearsText || '*'}`
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch cron format validation
        this.validateCronFormat()
      }
    },
    object (object) {
      this.setCronValue()
    },
    cron (cron) {
      this.setObjectTextValue()
    }
  }
}
</script>

<style lang="scss">
.el-popper {
  z-index: 1000000 !important;
}
.definition-wrapper.cron {
  #changeContab {
    border-radius: 5px;

    .language {
      position: absolute;
      right: 25px;
      z-index: 1;
    }
    .el-tabs {
      box-shadow: none;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .tabBody {
      .el-row {
        margin: 10px 0;

        .el-select {
          margin: 0 5px;
        }

        .long {
          .el-select {
            width: 350px;
          }
        }

        .el-input-number {
          width: 110px;
          margin: 0 5px;
        }
      }
    }
    .bottom {
      width: 100%;
      text-align: center;
      padding-bottom: 7px;
      padding-top: 7px;
      position: relative;
      background-color: #F5F7FA;
      color: #35495e;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;

      .value {
        font-size: 16px;
        vertical-align: middle;
      }
    }

    .el-radio__label,
    .el-tabs__item,
    .el-input__inner {
      font-size: 14px;
    }
    .el-tag {
      font-size: 14px;
    }
  }

  &.error_validate {
    #changeContab {
      border: 1px solid #df0000 !important;

      input {
        border: 1px solid #DCDFE6 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/cron.vue